import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './CircularPlusButton.css';
import Icon, { IconSizes, IconTypes, IconVariants } from '../foundations/Icon';

function CircularPlusButton({ className = '', onClick = () => {}, disabled = false }) {
    return (
        <div className={classNames(css.circularContainer, { [css.disabled]: disabled })}>
            <Icon
                disabled={disabled}
                className={className}
                name="add-fill"
                type={IconTypes.MINGCUTE}
                variant={IconVariants.WHITE}
                size={IconSizes.X_SMALL}
                onClick={onClick}
            />
        </div>
    );
}

CircularPlusButton.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
};

export default CircularPlusButton;
